module.exports = __webpack_public_path__ + "img/times.93f81811.svg";